import { render, staticRenderFns } from "./ProjectsHome.vue?vue&type=template&id=744a0e76&"
import script from "./ProjectsHome.vue?vue&type=script&lang=js&"
export * from "./ProjectsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports